module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuAgMAAAAq18OkAAAACVBMVEUAAAAeEwP///+P9O6FAAAAAXRSTlMAQObYZgAAACdJREFUKM9jYEAGoqFw4IDKEVsFAyvpygFbHzXKwc6hf5TgTiHIAAAMU/of4AtfUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/ico_address_selected.png
// module id = +ZoY
// module chunks = 0